// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__kUnE7","search":"Settings_search__1PB94","filter":"Settings_filter__2QEtw"};